import Vue from 'vue'
import {
    ValidationObserver,
    ValidationProvider,
    extend 
  } from "vee-validate"
import { 
    required, 
    email,
    confirmed,
    min
} from 'vee-validate/dist/rules';

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

extend("required", {
    ...required,
    message: "Tidak boleh kosong"
})

extend("email", {
    ...email,
    message: "Email harus valid"
});

extend('confirmed', {
    ...confirmed,
    message: "Password konfirmasi tidak cocok"
})

extend('min', min)